import {requiredTextAfterAttempt} from '../../../../helpers/validations'

const validations = {
  title: [requiredTextAfterAttempt('title', 'required-title')],
  type: [({attempted, type}) => {
    return (!attempted || type != '') ? '' : 'required-type'
  }],
  subject: [requiredTextAfterAttempt('subject', 'required-subject')],
  course: [requiredTextAfterAttempt('course', 'required-course')],
  topics: [({attempted, useGenerator, topics}) => {
    return (!attempted || !useGenerator || topics.length > 0) ? '' : 'required-topics'
  }],

}

export default validations
